import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, makeStyles } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { ECOMMBXLoader } from '../../../../content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';
import { MatchButtons } from '../../../../content-composer/src/components/Generic/MatchButtons';

type StepperActionsProps = {
  onClickCancel?: () => void;
  onClickSubmit?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading: boolean;
};

const useStyles = makeStyles(theme => ({
  loadingContainer: {
    marginBottom: theme.spacing(5),
  },
}));

const FormActions: FC<StepperActionsProps> = ({ onClickCancel, onClickSubmit, isLoading }) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <Box mt={6} mb={isMobile ? 4 : 0}>
      {isLoading && (
        <Grid item xs={12} className={classes.loadingContainer}>
          <ECOMMBXLoader size='small' verticalSpacing='small' />
        </Grid>
      )}
      <Box display={'flex'}>
        <MatchButtons
          isFullWidth={false}
          leftBtnFullWidth
          isLeftBtnDisabled={isLoading}
          onClickLeftBtn={onClickCancel}
          leftBtnLabel={t('fundsTransferPage.FormActions.Back')}
          isRightBtnDisabled={isLoading}
          rightBtnFullWidth
          onClickRightBtn={onClickSubmit}
          rightBtnLabel={t('fundsTransferPage.FormActions.Next')}
        />
      </Box>
    </Box>
  );
};

export { FormActions };
